/**
 * clientes.service.ts — CRUD del catálogo /clientes. GET sirve también de
 * autocomplete (?q=) para el combobox find-or-create de los formularios.
 */
import { httpGet, httpPost, httpPatch } from "@/shared/lib/http-client.js";
import { cacheCatalog } from "@/features/offline-sync/services/catalog-cache.js";
import type { CambiosClienteInput, Cliente, NuevoClienteInput } from "../types.js";

export async function listClientes(q?: string): Promise<Cliente[]> {
  const qs = q ? `?q=${encodeURIComponent(q)}` : "";
  if (qs) {
    // Search requests (with q=) are not suitable for full-catalog caching.
    return httpGet<Cliente[]>(`/clientes${qs}`);
  }
  // Full list fetch — cache to IDB opportunistically for offline use (S4-T3).
  return cacheCatalog("clientes", () => httpGet<Cliente[]>("/clientes"));
}

export async function createCliente(input: NuevoClienteInput): Promise<Cliente> {
  return httpPost<Cliente>("/clientes", input);
}

export async function updateCliente(id: string, cambios: CambiosClienteInput): Promise<Cliente> {
  return httpPatch<Cliente>(`/clientes/${id}`, cambios);
}
